import './App.css';
import capitalart from './logo1.png';
import loc from './loc.png';
import gsm from './gsm.png';
import email from './email.png';

function App() {
  return (
    <div className="container">
      <header className="header">
        <div className="top-image-box">
          <img
            src={capitalart}
            alt="Capitalart s.a."
            className="top-image"
          />
        </div>
      </header>

      <div className="text-box">
      <div className="text-item">
        <img src={loc} alt="Icon" className="icon" />
        <p className="line3" translate="no">7, Z.A.C. Klengbousbierg L-7795 Bissen, Luxembourg</p>
      </div>
      <div className="text-item">
        <img src={gsm} alt="Icon" className="icon" />
        <p className="line3">+ 352 691 563 846</p>
      </div>
      <div className="text-item">
        <img src={email} alt="Icon" className="icon" />
        <p className="line3" translate="no">info@capitalart.eu</p>
      </div>
    </div>
    </div>
  );
}

export default App;